(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoVirtualController', ReporteEvaluativoVirtualController);

    ReporteEvaluativoVirtualController.$inject = ['$scope', '$state', 'ReporteEvaluativoVirtualService', 'ReporteEvaluativoVirtualRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoVirtualController ($scope, $state, ReporteEvaluativoVirtualService,ReporteEvaluativoVirtualRegenerarService, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.save=save;
        vm.print=print;
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoVirtualRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoVirtualService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoVirtualService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
//            if(vm.wrapper.regenerar){
//            	$state.go('volvergenerarReporteVirtual', null, { reload: true });
//            }else{
            	if(vm.wrapper.tipoUser==1){
                    $state.go('generarReporteVirtual', {
        			 	idA: $stateParams.idA,
             			idP: $stateParams.idP,
             			idAnio: $stateParams.idAnio,
             			idIndice: $stateParams.idIndice,
             			ic: $stateParams.ic,
                        iic: $stateParams.iic,
             			tipoEvaluacion: $stateParams.tipoEvaluacion,
             			idDependencia: $stateParams.idDependencia,
             			nivell: $stateParams.nivell,
             			modeloo: $stateParams.modeloo
        			} , { reload: true });
                }else{
                	if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteVirtual', null, { reload: true });
                    }
                }
                    
//            }
            
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'identidadinstitucionalVir',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Es respetuoso cuando se expresa de la Universidad, de otros docentes o compañeros de trabajo.', 
            		'Muestra respeto al dirigirse hacia los estudiantes.', 
            		'Está comprometido con el proceso de formación del estudiante', 
            		'Muestra con el ejemplo congruencia entre lo que dice y hace.', 
            		'Promueve la ética de la profesión en su desempeño.',
            		'Demuestra tolerancia en el intercambio de conocimientos, experiencias y opiniones.',
            		'Evidencia compromiso social en su desempeño.'],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.respetounidocentes),
                	parseFloat(vm.reporte.respetoestudiantes),
                	parseFloat(vm.reporte.comprometidoformacionestudiante),
                	parseFloat(vm.reporte.congruenciadicehace),
                	parseFloat(vm.reporte.promueticadesemp),
                	parseFloat(vm.reporte.toleranciaconoexopin),
                	parseFloat(vm.reporte.evidenciacomprsocial)
                	],
               	color: '#002e5f'
            }]
        });
        
        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'ambientesaprendizajeVir',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Orienta el dominio de conocimientos, habilidades y actitudes, durante las sesiones.', 
            		'Promueve acciones para fortalecer el desempeño autónomo del estudiante.',
            		'Brinda herramientas complementarias que favorecen el aprendizaje.', 
            		'Utiliza diversas herramientas digitales (plataformas virtuales, base de datos, software, sitios web, bibliotecas virtuales).',
            		'Favorece el uso de herramientas digitales (plataformas virtuales, base de datos, software, sitios web) como recurso didáctico.',
            		'Promueve el uso de materiales y recursos en idioma inglés', 
            		'Utiliza actividades dentro y/o fuera del aula, que contribuyen al desarrollo del aprendizaje,',
            		'Utiliza actividades de aprendizaje que promueven el análisis de los contenidos.', 
            		'Utiliza actividades donde el estudiante integre conocimientos previos y nuevos.',
            		'Utiliza actividades que promueven el interés del estudiante hacia el aprendizaje de la asignatura.'
            		],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.orientaconohabact),
                	parseFloat(vm.reporte.promaccionesfortalecerestu),
                	parseFloat(vm.reporte.herrcomplementarias),
                	parseFloat(vm.reporte.herrdigitales),
                	parseFloat(vm.reporte.prominteracestu),
                	parseFloat(vm.reporte.materialesingles),
                	parseFloat(vm.reporte.habilidadaulavirtual),
                	parseFloat(vm.reporte.anacontenidos),
                	parseFloat(vm.reporte.actividadintegrepreviosnuevos),
                	parseFloat(vm.reporte.actividadinteresestu)
                	],
               	color: '#002e5f'
            }]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'evaluacionVir',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Establece el puntaje de cada una de las actividades de evaluación.',
            		'Respeta los criterios establecidos durante la asignatura.', 
            		'Informa la puntuación obtenida en cada una de las actividades.',
            		'Procura que las actividades de evaluación se relacionen con lo visto en la asignatura.', 
            		'Retroalimenta evidenciando fortalezas y debilidades de las actividades propuestas.',
            		'Resuelve dudas respecto a los contenidos abordados.', 
            		'Utiliza diferentes formas para evaluar los aprendizajes.'
            		],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.puntuajeeva),
                	parseFloat(vm.reporte.respetacriterios),
                	parseFloat(vm.reporte.informapuntacion),
                	parseFloat(vm.reporte.actrelacionen),
                	parseFloat(vm.reporte.retrofotalezasdevilidades),
                	parseFloat(vm.reporte.resuelvedudas),
                	parseFloat(vm.reporte.difformasevaluar)
                	],
               	color: '#002e5f'
            }]
        });
    }
})();